import { DONE_STEP, WELCOME_STEP, useParticipantSurvey } from "../survey";
import { LivePill, Logo } from "../ui";
import { PAPERNAUT_URL } from "../webinar";
import { Finish } from "./Finish";
import { QuestionStep } from "./QuestionStep";
import { Welcome } from "./Welcome";

export function Participant() {
	const { connected, progress, registration, stats, register, vote, goTo } = useParticipantSurvey();
	const { firstName } = progress;
	const step = firstName === null ? WELCOME_STEP : progress.step;

	return (
		<div className="flex min-h-dvh flex-col">
			<header className="mx-auto flex w-full max-w-2xl items-center justify-between gap-4 px-4 pt-5 pb-5 sm:px-6">
				<Logo className="h-7 w-auto sm:h-8" />
				<LivePill connected={connected} online={stats.online} />
			</header>

			<main className="mx-auto w-full max-w-2xl flex-1 px-4 pb-12 sm:px-6">
				{step === WELCOME_STEP ? (
					<Welcome
						firstName={firstName}
						participants={stats.participants}
						connected={connected}
						registration={registration}
						onRegister={register}
						onStart={() => goTo(step + 1)}
					/>
				) : step === DONE_STEP ? (
					<Finish progress={progress} stats={stats} onEdit={() => goTo(WELCOME_STEP + 1)} />
				) : (
					<QuestionStep
						key={step}
						index={step - 1}
						answers={progress.answers}
						stats={stats}
						onVote={vote}
						onBack={() => goTo(step - 1)}
						onNext={() => goTo(step + 1)}
					/>
				)}
			</main>

			<footer className="mx-auto w-full max-w-2xl px-4 pb-8 text-xs leading-relaxed text-muted-foreground sm:px-6">
				Wir speichern Ihren Namen, Ihre E-Mail-Adresse und Ihre Antworten zur Auswertung des Webinars; im
				Webinar erscheinen nur Gesamtergebnisse. Keine Cookies, kein Tracking. Eine Umfrage von Garden of
				Concepts GmbH ·{" "}
				<a className="underline underline-offset-2 hover:text-foreground" href={`${PAPERNAUT_URL}impressum/`} target="_blank" rel="noopener">
					Impressum
				</a>{" "}
				·{" "}
				<a className="underline underline-offset-2 hover:text-foreground" href={`${PAPERNAUT_URL}datenschutz/`} target="_blank" rel="noopener">
					Datenschutz
				</a>
			</footer>
		</div>
	);
}
